import { PropType, defineComponent } from 'vue'

import { ProgressStep } from './MsProgressBar.interface'

export default defineComponent({
    name: 'MsProgressBar',
    props: {
        numberOfSteps: {
            type: Number,
            required: true,
        },
        currentStep: {
            type: Number,
            required: true,
        },
        progressSteps: {
            type: Array as PropType<ProgressStep[]>,
            required: true,
        },
        text: {
            type: String,
            default: 'ausgefüllt',
        },
    },
    setup(props) {
        function getWidthPercentage(): string {
            if (props.currentStep === 0) {
                return '1%'
            }

            const percent = (props.currentStep / props.numberOfSteps) * 100

            return `${Math.ceil(percent)}%`
        }

        function getColorClass(): string {
            return findActiveStep()?.colorClass || ''
        }

        function getText(): string {
            return findActiveStep()?.text || ''
        }

        function findActiveStep() {
            return props.progressSteps.find((step) => step.lastStep >= props.currentStep)
        }

        return {
            getWidthPercentage,
            getColorClass,
            getText,
        }
    },
})
